import React from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";
import { styles } from "./element";
const NewButtonItem = ({ title, helpcontent, ...props }) => {
  return (
    <div>
      <Button size="medium" content={title} {...props} style={styles} />
      {helpcontent ? (
        <span
          style={{
            color: "#000000",
            fontWeight: "bold",
            position: "relative",
            left: -15,
          }}
        >
          {helpcontent}
        </span>
      ) : null}
    </div>
  );
};

NewButtonItem.propTypes = {
  title: PropTypes.any,
};
export default NewButtonItem;
